/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'phone': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M704.144 1024H319.856c-53.024 0-96-42.976-96-96V96c0-53.024 42.976-96 96-96h384.288c53.04 0 96 42.976 96 96v832c0 53.024-42.96 96-96 96zm32-928c0-17.664-14.336-32-32-32H319.856c-17.648 0-32 14.336-32 32v832c0 17.664 14.352 32 32 32h384.288c17.664 0 32-14.336 32-32V96zm-160.096 64h-128c-17.68 0-32-14.32-32-32s14.32-32 32-32h128c17.68 0 32 14.32 32 32s-14.32 32-32 32zm-64 640.176c35.28 0 63.84 28.592 63.84 63.808 0 35.248-28.56 63.856-63.84 63.856s-63.84-28.608-63.84-63.856c0-35.216 28.56-63.808 63.84-63.808z"/>'
  }
})
